import { Methods } from "@newview/infrastructure";
import {NewviewWebsiteBaseApi} from "./NewviewWebsiteBaseApi";


export class WebsiteProductServiceSystemFeatureApi extends NewviewWebsiteBaseApi {

  public get ControllerName(): any {
    return 'website-product-service-system-feature'
  }



}